import RightPopupComponent from "components/RightPopup";

import { ReactComponent as ParkingIcon } from 'icons/pages/app/parking.svg';
import { ReactComponent as InsuranceCompanyIcon } from 'icons/pages/app/insuranceCompany.svg';
import { ReactComponent as AdvertIcon } from 'icons/pages/app/advert.svg';

import '../index.less';
import '../themes/default.less';

export default class ShowContent extends RightPopupComponent {

    render() {

        const { info, recommendationTypes, customField, renderAvatar } = this.props;
        const { clientStatuses } = this._config;
        const { sex, status, knowAboutClinicDetails, discount, statusTreatment,
            smileKeeper, phoneNumber, phoneWorkingNumber, personalData: pr, birthday,
            allergy, isEmployee, vipStatus, egiszPublishEnable, visitPersonConfiguring,
            patientVehicle, lkSearchAttr1, insurance, personDelegateDate, city,
            contactData, commercialEnable, isGratitude } = info;

        const personalData = (pr || {});
        const pdd = (personDelegateDate || {});
        const cd = (contactData || {});
        const { whatsappEnable, smsEnable, phoneEnable, telegramEnable, telegramUserName } = cd;
        let telegramEnableText = "Нет";
        if (telegramEnable) {
            telegramEnableText = "Да ";
            telegramEnableText += !telegramUserName ? "Аккаунт Telegram по номеру телефона" : "Имя пользователя в Telegram " + telegramUserName;
        }

        const ce = (commercialEnable || {});
        const { whatsapp, sms, phone, push, telegram, email } = ce;

        const sexValue = sex === "FEMALE" ? 1 : sex === "MALE" ? 0 : null;
        const statusName = clientStatuses.find(it => it.id === status);
        const recommName = knowAboutClinicDetails ? recommendationTypes.find(it => it.id === knowAboutClinicDetails.recommendationType.id) : null;

        const infoPC = (visitPersonConfiguring || {});

        const fullName = this._helper.string.formatFullName(info);
        const { vehicles, parkingPriority } = (patientVehicle || {});
        const modePark = parkingPriority === "NOT_NECESSARY" ? "Не нужна" :
            parkingPriority === "REQUIRED" ? "Спрашивать" : "Сразу оформлять";

        return (<div className="flex gap16 col">
            {renderAvatar()}
            {this.renderRow("client.fio", fullName)}
            {this.renderRow("main.dateBirth", birthday ? this._helper.date.toDateStr(birthday) : "")}
            {this.renderRow("client.sex", sexValue === 1 ? this.tr("sex.female") : this.tr("sex.male"))}
            {this.renderRow("client.status", statusName ? this.tr(statusName.name) : "")}
            {this.renderRow("Статус лечения", statusTreatment ? this.tr(`clientStatuses.${statusTreatment}`) : "")}
            {this.renderRow("main.telephone", `${phoneNumber} ${lkSearchAttr1 ? "(основной)" : ""}`)}
            {this.renderRow("Vip", vipStatus ? "Да" : "Нет")}
            {this.renderRow("Smile keeper", smileKeeper ? "Да" : "Нет")}
            {this.renderRow("Сотрудник", isEmployee ? "Да" : "Нет")}
            {this.renderRow("Программа благодарности", isGratitude ? "Да" : "Нет")}
            {this.renderRow("client.email", personalData['EMAIL'] ? personalData['EMAIL'] : "-", "Blue")}
            {this.renderRow("client.homePhone", personalData['PHONE_1'] ? personalData['PHONE_1'] : "-")}
            {this.renderRow("client.specMarks", personalData['SPEC_NOTES'] ? personalData['SPEC_NOTES'] : "-")}
            {this.insertLine()}
            {this.insertParagraf("Визиты подтверждает другой человек")}
            {this.renderRow("client.fio", `${infoPC.lastName || ""} ${infoPC.firstName || ""} ${infoPC.middleName || ""}`)}
            {this.renderRow("Кем приходится", infoPC.patientRelative)}
            {this.renderRow("main.telephone", infoPC.phoneNumber)}
            {this.insertLine()}
            <div className="flex gap8">
                {this.insertParagraf("Парковка")}
                <ParkingIcon />
            </div>
            {this.renderRow("Статус", modePark)}
            {vehicles?.map((it, i) => (<div key={"field_" + i} className="flex gap16">
                {this.renderRow("Автомобиль", `${it.mark} ${it.number}`)}
            </div>))}
            {this.insertLine()}
            {this.renderRow("Скидка", (discount ? discount : 0) + " %")}
            {this.insertLine()}
            {this.renderRow("Передавать данные в ЕГИСЗ", egiszPublishEnable ? "Да" : "Нет")}
            {this.insertLine()}
            <div className="flex gap8">
                {this.insertParagraf("СНИЛС и страхование")}
                <InsuranceCompanyIcon />
            </div>
            {this.renderRow("СНИЛС", personalData['SNILS'] ? personalData['SNILS'] : "-")}
            {this.renderRow("client.policy", personalData['OMS'])}
            {this.renderRow("Страховая компания ДМС", insurance?.name ? insurance.name : "Не выбрано")}
            {this.renderRow("client.vhiPolicy", personalData['DMS'])}
            {this.renderRow("client.contract", personalData['CONTRACT'])}
            {this.insertLine()}
            {this.insertParagraf("main.work")}
            {this.renderRow("client.workPhone", phoneWorkingNumber ? phoneWorkingNumber : "-")}
            {this.renderRow("client.kindActivity", personalData['JOB_KIND'] ? personalData['JOB_KIND'] : "-")}
            {this.renderRow("client.placeWork", personalData['JOB_PLACE'] ? personalData['JOB_PLACE'] : "-")}
            {this.insertLine()}
            {this.insertParagraf("client.birthCertificate")}
            {this.renderRow("client.seriesAndNumber", `${personalData['BC_SERIES'] || ""} ${personalData['BC_NUMBER'] || ""}`)}
            {this.renderRow("client.whenIssued", personalData['BC_ISSUE_DATE'])}
            {this.renderRow("client.issuedBy", personalData['BC_ISSUED_BY'])}
            {this.insertLine()}
            {this.insertParagraf("client.passport")}
            {this.renderRow("client.seriesAndNumber", `${personalData['PSP_SERIES'] || ""} ${personalData['PSP_NUMBER'] || ""}`)}
            {this.renderRow("client.whenIssued", personalData['PSP_ISSUE_DATE'])}
            {this.renderRow("client.issuedBy", personalData['PSP_ISSUED_BY'])}
            {this.renderRow("client.departmentCode", personalData['PSP_DEP_CODE'])}
            {this.renderRow("client.placeBirth", personalData['BIRTH_PLACE'])}
            {this.renderRow("client.citizenship", personalData['CITIZENSHIP'])}
            {this.renderRow("client.homeAddress", personalData['ADDRESS'] ? personalData['ADDRESS'] : "-")}
            {this.renderRow("client.registrAddress", personalData['REG_ADDRESS'] ? personalData['REG_ADDRESS'] : "-")}
            {this.insertLine()}
            {this.insertParagraf("Законный представитель")}
            {this.renderRow("client.fio", `${pdd.lastName || ""} ${pdd.firstName || ""} ${pdd.middleName || ""}`)}
            {this.renderRow("main.telephone", `${pdd?.phoneNumber ? pdd.phoneNumber : ""}`)}
            {this.renderRow("Кем приходится", pdd.relative)}
            {this.renderRow("СНИЛС", pdd.snils)}
            {this.renderRow("Паспортные данные", ``)}
            {this.renderRow("client.seriesAndNumber", `${pdd.seriesPSP || ""} ${pdd.numberPSP || ""}`)}
            {this.renderRow("client.whenIssued", pdd.issueDatePSP)}
            {this.renderRow("client.issuedBy", pdd.issuedBy)}
            {this.renderRow("client.departmentCode", pdd.depCodePSP)}
            {this.renderRow("client.placeBirth", pdd.birthPlace)}
            {this.renderRow("client.citizenship", pdd.citizenship)}
            {this.renderRow("client.homeAddress", pdd.address)}
            {this.insertLine()}
            {this.renderRow("Аллергия", allergy ? allergy : "-")}
            {this.insertLine()}
            {this.renderRow("client.city", city?.name ? city.name : "Не указано")}
            {this.insertLine()}
            {this.insertParagraf("Канал для уведомлений о приёме")}
            {this.renderRow("WhatsApp", whatsappEnable ? "Да" : "Нет")}
            {this.renderRow("Telegram", telegramEnableText)}
            {this.renderRow("SMS", smsEnable ? "Да" : "Нет")}
            {this.renderRow("Звонок", phoneEnable ? "Да" : "Нет")}
            {this.insertLine()}
            <div className="flex gap8">
                {this.insertParagraf("Рекламные рассылки")}
                <AdvertIcon />
            </div>
            {this.renderRow("WhatsApp", whatsapp ? "Да" : "Нет")}
            {this.renderRow("Telegram", telegram ? "Да" : "Нет")}
            {this.renderRow("SMS", sms ? "Да" : "Нет")}
            {this.renderRow("Звонок", phone ? "Да" : "Нет")}
            {this.renderRow("Email", email ? "Да" : "Нет")}
            {this.renderRow("Push-уведомления в приложении", push ? "Да" : "Нет")}
            {this.insertLine()}
            {this.insertParagraf("client.emergencyComm")}
            {this.renderRow("client.contact", `${personalData['SOS_PHONE'] || ""} ${personalData['SOS_CONTACT'] || ""}`)}
            {this.renderRow("client.nameParents", personalData['PARENTS_NAME'])}
            {this.insertLine()}
            {this.renderRow("main.learned", recommName ? recommName.title : "")}
            {this.insertLine()}
            {customField?.map((it, i) => (<div key={"field_" + i} className="flex gap16">
                {this.renderRow(it.name, it.value)}
            </div>))}
        </div>);
    }
}

